module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"requestLogin":"DEN TRENDMANAGER KENNENLERNEN","contact":"https://www.trendmanager.com/de/"},"en":{"requestLogin":"GET TO KNOW THE TRENDMANAGER","contact":"https://www.trendmanager.com/en/"}}')
  delete Component.options._Ctor
}
